export const DEMO_CHANNEL_ID = 'a1ca9dac7ee44d52a41868329471105b';
export const DEMO_VIDEO_ID = 'c01fe227bbde48ddb51fb744ba8a4b75';
//# sourceMappingURL=demo.js.map